import request from './request';

/**
 * Dashboard roles and what they are allowed to open.
 *
 * `permissions` is the catalogue of sections a role can be given, not the ones
 * a particular role has — the picker is built from it so the dashboard and the
 * server agree on the list without either hard-coding the other's copy.
 *
 * `mine` is the signed-in admin's own access, and is deliberately not behind
 * the staff permission: the sidebar cannot be drawn without it.
 */
const roleService = {
  getAll: (params) => request.get('dashboard/admin/roles', { params }),
  permissions: () => request.get('dashboard/admin/roles/permissions'),
  mine: () => request.get('dashboard/admin/my-permissions'),
  create: (data) => request.post('dashboard/admin/roles', data),
  update: (id, data) => request.put(`dashboard/admin/roles/${id}`, data),
  delete: (id) => request.delete(`dashboard/admin/roles/${id}`),
};

export default roleService;
